import { Meteor } from 'meteor/meteor';
import { check } from 'meteor/check';

import Layers from '../Layers';
import { getDefaultBaseMap } from '../../Users/user-operations';

Meteor.publish('layers', function layers() {
  return Layers.find({ owner: this.userId });
});
Meteor.publish('layers.all', function layers() {
  return Layers.find();
});

// Note: layers.view is also used when editing an existing document.
Meteor.publish('layers.view', function layersView(layerId = '') {
  check(layerId, String);
  return Layers.find({
    _id: { $in: [layerId, getDefaultBaseMap(Meteor.user())] },
    owner: this.userId
  });
});

Meteor.publish('layers.viewMap', function layersViewMap(layerIds = []) {
  check(layerIds, [String]);
  return Layers.find({
    owner: this.userId,
    _id: { $in: [...layerIds, getDefaultBaseMap(Meteor.user())] }
  });
});

Meteor.publish('layers.viewPublicMap', function layersViewPublicMap(layerIds) {
  return Layers.find(
    { _id: { $in: layerIds }, deleted: { $eq: 'no' } },
    {
      fields: {
        // TODO: poner los campos que no quiero compartir.
        owner: 0
      }
    }
  );
});

Meteor.publish('layers.public', () => {
  return Layers.find(
    { deleted: { $eq: 'no' } },
    {
      fields: {
        // TODO: poner los campos que no quiero compartir.
        owner: 0
      }
    }
  );
});

Meteor.publish('layers.publicData', publicLayerDataId => {
  check(publicLayerDataId, String);
  return Layers.find(
    { publicDataId: publicLayerDataId, sharedData: true, deleted: { $eq: 'no' } },
    { fields: { owner: 0 } }
  );
});

Meteor.publish('layers.privateData', publicLayerDataId => {
  check(publicLayerDataId, String);
  return Layers.find(
    { publicDataId: publicLayerDataId, sharedPrivateData: true, deleted: { $eq: 'no' } },
    { fields: { owner: 0 } }
  );
});

Meteor.publish('layers.allBasicInfo', function layersBasicInfo() {
  return Layers.find({}, { fields: { _id: 1, name: 1 } });
});

Meteor.publish('layers.allGeoJSON', function allGeoJSON(fieldsProp) {
  check(fieldsProp, Object);
  const query = { layerSubType: 'GeoJSON' };
  const options = { fields: fieldsProp };
  return Layers.find(query, options);
});

Meteor.publish('layers.allUserBasicInfo', function layersBasicInfo() {
  return Layers.find({ owner: this.userId }, { fields: { _id: 1, name: 1 } });
});
